export default {
  netFeedIn: {
    UNKNOWN: "Unbekannt",
    SINGLE_PHASE: "Einphasig",
    TWO_PHASE: "Zweiphasig",
    THREE_PHASE: "Dreiphasig",
  },
};
